import { BrandVariants, createLightTheme, createDarkTheme } from '@fluentui/react-components';

const knowee: BrandVariants = {
  10: "#020403",
  20: "#0F1C16",
  30: "#142F24",
  40: "#173C2D",
  50: "#194A37",
  60: "#1A5942",
  70: "#1B684C",
  80: "#1A7757",
  90: "#188762",
  100: "#14976D",
  110: "#22A67A",
  120: "#4FB38C",
  130: "#6FBF9D",
  140: "#8DCCB0",
  150: "#A9D8C2",
  160: "#C4E5D5"
};

export const knoweeLightTheme = createLightTheme(knowee);
export const knoweeDarkTheme = createDarkTheme(knowee);
